import {
	type Person,
	PersonSchema,
	type ProfileDatum,
} from "@/FundExplorer/types";
import { useMemo } from "react";

export default function useManagers(profiles: ProfileDatum[]): Person[] {
	return useMemo(
		() =>
			Object.values(
				profiles.reduce(
					(acc, profile) => {
						const personId = `${profile.person}`;
						const profileId = `${profile.localId}`;
						const person =
							acc[personId] ??
							PersonSchema.parse({
								...profile,
								id: personId,
								profiles: [],
								funds: [],
							});
						const profileIds = new Set(person.profiles.concat([profileId]));
						const funds = new Set(person.funds.concat(profile.funds));
						person.profiles = Array.from(profileIds.values());
						person.funds = Array.from(funds.values());
						acc[personId] = person;
						return acc;
					},
					{} as Record<string, Person>,
				),
			),
		[profiles],
	);
}
